/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ScrollMenu from 'react-horizontal-scrolling-menu';
import ContentItem from '../../components/ContentItemEnd';

class SameGenreContent extends Component {
  state = {
    menuIndex: 0,
    slideIndex: 1,
    tagIndex: 0,
    slidePlay: true,
    mouseOn: false,
    onEvent: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { contentSerial } = this.props.childProps;
    this._getGenre(contentSerial);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    );
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)

    if (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    ) {
      this._getGenre(nextProps.childProps.contentSerial);
    }
  };
  _getGenre = async (contentSerial) => {
    // const { loginId } = this.props;

    //if(loginId === null || loginId === undefined || loginId === '') {

    //} else {
    const result = await this._getGenreApi(contentSerial);
    const intReturn = result.data[0].intReturn;
    const genreList = result.data[0].listData;

    ////console.log(genreCode)
    let genreCode;
    if (intReturn === 0) {
      if (this._isMounted) {
        if (genreList.length > 0) {
          genreCode = genreList[0].genreCode;
        }
        this.setState({
          genreList,
          genreCode,
        });
        console.log(genreCode);
        setTimeout(() => {
          this._getContent(genreCode);
        }, 700);
      }
    }
    //}
  };
  _getGenreApi = (contentSerial) => {
    const { apiUrl, loginId } = this.props;
    //const { contentSerial } = this.props.childProps;
    ////console.log(contentSerial)
    ////console.log(apiUrl + '/matchingOne?userid=' + loginId + '&contentSerial=' + contentSerial)
    return axios(
      apiUrl +
        '/matchingOne?userid=' +
        loginId +
        '&contentSerial=' +
        contentSerial
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getContent = async (genreCode) => {
    // const { loginId } = this.props;

    const result = await this._getContentApi(genreCode);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;
    //console.log(contentList)
    if (intReturn === 0) {
      this.setState({
        contentList,
      });
    }
  };
  _getContentApi = (genreCode) => {
    const { apiUrl, loginId } = this.props;

    return axios(
      apiUrl + '/sameGenreContent?genreCode=' + genreCode + '&userid=' + loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _renderItem = () => {
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <div key={index} style={{ float: 'left' }}>
          <ContentItem
            refer={'sametime'}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            contentPartSerial={item.contentPartSerial}
            num={index + 1}
            onEndItemSlide={this._onEndItemSlide}
            cashOnly={item.cashOnly}
          />
        </div>
      );
    });

    return list;
  };
  _onEndItemSlide = (num, over) => {
    const { slideIndex } = this.state;
    let scrollPos;
    ////console.log(slideIndex)
    if (num === null || num === '' || num === undefined) {
      //console.log()
    } else {
      //console.log(over, num, slideIndex)
      if (over) {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 1;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 7;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 13;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 19;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      } else {
        if (num % 6 === 0) {
          if (slideIndex === 1) {
            scrollPos = 0;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 2) {
            scrollPos = 6;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 3) {
            scrollPos = 12;
            this.scrollMenu.scrollTo(scrollPos.toString());
          } else if (parseInt(slideIndex) === 4) {
            scrollPos = 18;
            this.scrollMenu.scrollTo(scrollPos.toString());
          }
        }
      }
    }
  };
  _onToggleMouseOn = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: true,
    });
  };
  _onToggleMouseOff = () => {
    //const { mouseOn } = this.state;

    this.setState({
      mouseOn: false,
    });
  };
  _onSelect = (key) => {
    //console.log(key)
  };
  _arrowNext = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    const page = Math.round(cnt / 6);

    if (slideIndex < page) {
      this.setState({
        slideIndex: slideIndex + 1,
      });
    }
  };
  _arrowPrev = () => {
    const { slideIndex } = this.state;
    // const cnt = contentList.length;
    // const page = Math.round(cnt / 6);

    //if(slideIndex < 1) {
    this.setState({
      slideIndex: slideIndex - 1,
    });
    //}
  };
  _renderDot = () => {
    const { slideIndex, contentList } = this.state;
    const cnt = contentList.length;
    let page = Math.round(cnt / 6);
    if (page === 0) {
      page = 1;
    }
    //console.log(page, cnt)
    let arr = [];

    for (let i = 1; i <= page; i++) {
      arr.push(<em key={i} className={i === slideIndex ? 'on' : null}></em>);
    }
    const list = arr.map((item) => {
      return item;
    });
    ////console.log()
    return list;
  };
  _renderTag = () => {
    const { tagList, tagIndex } = this.state;

    const list = tagList.map((item, index) => {
      return (
        <span
          key={index}
          className={index === tagIndex ? 'on' : null}
          onClick={() => this._onTagClick(index, item.tagCode)}
        >
          #{item.tag}
        </span>
      );
    });

    return list;
  };
  _onTagClick = (index, tagCode) => {
    this.setState({
      tagIndex: index,
    });
    this._getContent(tagCode);
  };
  _onMore = () => {
    const { genreCode } = this.state;
    const { history } = this.props;
    history.push('/list?q=genre&c=' + genreCode);
  };
  render() {
    const { contentList, mouseOn, slideIndex, genreList } = this.state;
    // const { contentSerial } = this.props.childProps;
    return (
      <Fragment>
        {contentList ? (
          contentList.lenght > 0 ? (
            <div className="main_list_style">
              <a name="genre"></a>
              <h1>
                <strong>{genreList[0].title}와 유사한 장르</strong>

                <div>
                  {this._renderDot()}

                  <a style={{ cursor: 'pointer' }} onClick={this._onMore}>
                    더보기
                  </a>
                </div>
              </h1>
              <div
                className="main_list_goup1"
                onMouseEnter={this._onToggleMouseOn}
                onMouseLeave={this._onToggleMouseOff}
              >
                <div className="div_ul">
                  <ScrollMenu
                    data={contentList ? this._renderItem() : null}
                    arrowLeft={
                      mouseOn ? (
                        slideIndex === 1 ? null : (
                          <a
                            className="left_btn"
                            style={{ cursor: 'pointer' }}
                            onClick={this._arrowPrev}
                          >
                            <span className={'on'}>이전</span>
                          </a>
                        )
                      ) : null
                    }
                    arrowRight={
                      mouseOn ? (
                        slideIndex > parseInt(contentList.length / 6) ? null : (
                          <a
                            className="right_btn"
                            style={{ cursor: 'pointer' }}
                            onClick={this._arrowNext}
                          >
                            <span className={'on'}>다음</span>
                          </a>
                        )
                      ) : null
                    }
                    wheel={false}
                    dragging={true}
                    transition={0.5}
                    translate={2}
                    alignOnResize={true}
                    //inertiaScrolling={true}
                    //inertiaScrollingSlowdown={3}
                    //wrapperStyle={{border: 0, backgroundColor: '#000'}}
                    alignCenter={false}
                    hideSingleArrow={true}
                    hideArrows={mouseOn}
                    ref={(ref) => (this.scrollMenu = ref)}
                    scrollBy={6}
                  />
                </div>
                <div className="clear"></div>
              </div>
            </div>
          ) : null
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(SameGenreContent));
